module.exports = __webpack_public_path__ + "img/music-test-icon8.e1b45949.png";